<script>
import './stylesheets/components/VsButtonToggle';

import isObject from 'lodash/isObject';

import VsLayout from './VsLayout';

export default {
  components: {
    VsLayout,
  },
  props: {
    options: Array,
    selectedOption: String,
    processing: Boolean,
  },
  data: () => ({
    isObject,
  }),
};
</script>

<template lang='pug'>
vs-layout.vs-button-toggle(no-gutter, auto-xs, grow-xs)
  template(v-for='option in options')
    button.vs-button-toggle__button(
      v-if='isObject(option)',
      :key='option.value',
      :class='{ "vs-button--disabled": option.value !== selectedOption, "vs-button-toggle__button--disabled": processing }',
      :disabled='option.value === selectedOption || processing',
      @click='$emit("toggle", option.value)',
    ) {{option.text}}
    button.vs-button-toggle__button(
      v-else,
      :key='option',
      :class='{ "vs-button--disabled": option !== selectedOption, "vs-button-toggle__button--disabled": processing }',
      :disabled='option === selectedOption || processing',
      @click='$emit("toggle", option)',
    ) {{option}}
</template>